import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";

import { Influencer, InfluencerContact } from "@shared/lib/types/influencer";
import { InfluencerService } from "../services/influencer.service";
import { BackednResponse } from "@shared/lib/types";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";

export function useRemoveReview() {
  const {
    mutate: removeReview,
    isLoading: isRemoving,
    isSuccess: isRemoved,
  } = useMutation<
    { influencerId: string; reviewId: string },
    BackednResponse<Influencer> | void
  >({
    mutationFn: async ({ influencerId, reviewId }) => {
      return await InfluencerService.deleteReview(influencerId, reviewId).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      queryKey: INFLUENCER_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data, { influencerId }) => {
      c.invalidateQueries({ queryKey: INFLUENCER_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...INFLUENCER_LIST_QUERY_KEY, influencerId],
      });
    },
  });

  return {
    removeReview,
    isRemoving,
    isRemoved,
  };
}
